import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  subtitle: {
    id: 'pib_communicate_section_title_1',
  },
  vocabularyCta: {
    id: 'pib_communicate_cta_3',
  },
  topSectionDescription: {
    id: 'pib_communicate_top_section_description',
  },
  bottomSectionDescription: {
    id: 'pib_communicate_bottom_section_description',
  },
  learningCta: {
    id: 'pib_communicate_section_cta',
  },
  pibLearn: {
    id: 'pib_learn',
  },
  pibCommunicate: {
    id: 'pib_communicate',
  },
  pibAllRightReserved: {
    id: 'pib_all_rights_message',
  },
});

export const en_us = defineMessages({
  title: {
    id: 'pib_communicate_section_title_2_en',
  },
  description: {
    id: 'pib_communicate_section_description_en',
  },
  leftSectionTitle: {
    id: 'pib_communicate_top_section_title_en',
  },
  leftSectionDescription: {
    id: 'pib_learn_immerse_description_en',
  },
  bottomSectionTitle: {
    id: 'pib_communicate_bottom_section_title_en',
  },
});

export const es = defineMessages({
  title: {
    id: 'pib_communicate_section_title_2_es',
  },
  description: {
    id: 'pib_communicate_section_description_es',
  },
  leftSectionTitle: {
    id: 'pib_communicate_top_section_title_es',
  },
  leftSectionDescription: {
    id: 'pib_learn_immerse_description_es',
  },
  bottomSectionTitle: {
    id: 'pib_communicate_bottom_section_title_es',
  },
});
